import request from '@/utils/request'

/**
 * 获取权限类型列表
 * GET /api/admin/sub-admin/permissions-types
 */
export function getPermissionTypes() {
  return request({
    url: '/api/admin/sub-admin/permissions-types',
    method: 'get'
  })
}

/**
 * 获取子管理员列表
 * GET /api/admin/sub-admin
 */
export function getSubAdminList() {
  return request({
    url: '/api/admin/sub-admin',
    method: 'get'
  })
}

/**
 * 查询当前用户权限
 * GET /api/admin/auth/my-permissions
 */
export function getMyPermissions() {
  return request({
    url: '/api/admin/auth/my-permissions',
    method: 'get'
  })
}

/**
 * 查询指定用户权限
 * GET /api/admin/sub-admin/{userId}/permissions
 * @param {string} userId - 用户ID
 */
export function getUserPermissions(userId) {
  return request({
    url: `/api/admin/sub-admin/${userId}/permissions`,
    method: 'get'
  })
}

/**
 * 设置子管理员
 * POST /api/admin/sub-admin
 * @param {Object} data - 设置数据
 * @param {string} data.userId - CENTER角色用户ID
 * @param {string[]} data.permissions - 权限列表
 * @param {string} [data.remark] - 备注
 */
export function setSubAdmin(data) {
  return request({
    url: '/api/admin/sub-admin',
    method: 'post',
    data
  })
}

/**
 * 移除子管理员
 * DELETE /api/admin/sub-admin/{userId}
 * @param {string} userId - 用户ID
 */
export function removeSubAdmin(userId) {
  return request({
    url: `/api/admin/sub-admin/${userId}`,
    method: 'delete'
  })
}

/**
 * 获取可作为子管理员的候选用户（CENTER角色）
 * GET /api/admin/users/candidates
 */
export function getSubAdminCandidates(params) {
  return request({
    url: '/api/admin/employees',
    method: 'get',
    params
  })
}
